import { useProductStore } from "../hooks/useProductStore";
import { useArticleStore } from "../hooks/useArticleStore";

export const useTieneDespachos = () => {
  const { productos } = useProductStore();
  const { articulosClickeados } = useArticleStore();

  // Verificar productos del store
  const tieneProductosCombustible =
    productos && productos.length > 0 && productos.some(producto => producto.idDespacho || (producto.idArticulo && producto.esCombustible === true));

  // Verificar artículos del store
  const tieneArticulosCombustible =
    articulosClickeados &&
    articulosClickeados.length > 0 &&
    articulosClickeados.some(articulo => articulo.idDespacho || (articulo.idArticulo && articulo.esCombustible === true));

  // Si alguno de los stores tiene combustibles, entonces tiene despachos
  return tieneProductosCombustible || tieneArticulosCombustible;
};
